export { TextHighlight, type TextHighlightColors } from './TextHighlight';
